import { Box, Grid, Link, Typography } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { InputAdornment } from "@mui/material";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory, withRouter } from "react-router-dom";
import vis_forgot_password from "../../assets/images/onboard/forgot_password.svg";
import info from "../../assets/images/onboard/info.svg";
import infoHover from "../../assets/images/onboard/infoIconHover.svg";
import forgot_password from "../../assets/USA_Images/login_images/forgotPass.svg";
import { ReactComponent as USAPassIcon } from "../../assets/USA_Images/login_images/pass_icon.svg";
import USACustomTextfield from "../../components/CustomInputs/USACustomTextfield";
import Toast from "../../components/ToastContainer/CustomToast";
import { codeValidation, resetPassword } from "../../slices/User";
import CommonUtil from "../../Util/CommonUtils";
import "./custom.css";
import LoginLayoutV2 from "./LoginLayoutV2";

const useStyles = makeStyles((theme) => ({
  form: {
    // width: "80%",
    marginTop: theme.spacing(3),
    backgroundColor: "rgb(15 90 156 / 17%)",
    backdropFilter: "blur(5px)",
  },
  submit: {
    backgroundColor: "#36c96d",
    borderRadius: "0.2rem",
    padding: "10px",
    "&:hover": {
      background: "#119743",
    },
  },
}));

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#f5f5f9d6",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 300,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #2281AB",
    marginRight: "180px",
  },
}));

function ChangePassword(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const classes = useStyles();
  const history = useHistory();
  const [values, setValues] = useState({
    password: "",
    showPassword: false,
    confirmPassword: "",
    confirmShowPassword: false,
  });

  const [code, setCode] = useState("");

  useEffect(() => {
    const url = new URL(window.location.href);
    const code = url.searchParams.get("code");

    if (code) {
      setCode(code);
      checkCodeValidation(code);
    }
  }, []);

  const checkCodeValidation = (code) => {
    dispatch(codeValidation(code))
      .unwrap()
      .then((exists) => {
        if (!exists) {
          Toast(t("This user already updated password"), "error");
          history.push("/vis/result-page");
        }
      })
      .catch(() => {
        Toast(t("Something went wrong"), "error");
      });
  };
  const [error, setError] = useState({
    showPassword: false,
    confirmPassword: false,
  });

  const handleChange = (event) => {
    const value = event.target.value;
    const name = event.target.name;

    setValues({
      ...values,
      [name]: value,
    });
    setError({
      [name]: false,
    });
  };

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleClickConfirmShowPassword = () => {
    setValues({ ...values, confirmShowPassword: !values.confirmShowPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const user = {
      password: values.password,
      confirmPassword: values.confirmPassword,
      code: code,
    };

    if (CommonUtil.isEmptyString(values.password)) {
      setError({ ...error, password: true });
      Toast(t("REGISTERUSER0002"), "error");
      return;
    }

    if (
      !values.password.match(
        /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()+=-\?;,./{}|\":<>\[\]\\\' ~_]).{8,}/,
      )
    ) {
      setError({ ...error, password: true });
      Toast(t("PASSWORDERROR"), "error");
      return;
    }
    if (CommonUtil.isEmptyString(values.confirmPassword)) {
      setError({ ...error, confirmPassword: true });
      Toast(t("REGISTERUSER0004"), "error");
      return;
    }

    if (
      !values.confirmPassword.match(
        /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()+=-\?;,./{}|\":<>\[\]\\\' ~_]).{8,}/,
      )
    ) {
      setError({ ...error, confirmPassword: true });
      Toast(t("PASSWORDERROR"), "error");
      return;
    }

    if (values.password !== values.confirmPassword) {
      setError({ ...error, confirmPassword: true });
      Toast(t("REGISTERUSER0007"), "error");
      return false;
    }
    dispatch(resetPassword(user))
      .unwrap()
      .then((data) => {
        if (data.code === "CVAI0601") {
          history.push("/vis/success-screen");
        } else {
          Toast(data.message, "error");
          onFail(data);
        }
      })
      .catch((er) => {});
  };

  const onFail = (data) => {
    switch (data.code) {
      case "CVAE0607":
        Toast("REGISTERUSER0007", "error");
        break;
      case "CVAE0603":
        Toast("Password is required", "error");
        break;
      case "CVAE0605":
        Toast("Confirm Password is required", "error");
        break;
      case "CVAE0612":
        history.push("/vis/result-page");
        break;
      case "CVAE0606":
        Toast(t("REGISTERUSER0007"), "error");
        break;
      default:
        break;
    }
  };

  const [confirmPasswordHover, setConfirmedPasswordHover] = useState(false);
  const [newPasswordHover, setNewPasswordHover] = useState(false);

  const handleConfirmPasswordHover = () => {
    setConfirmedPasswordHover(!confirmPasswordHover);
  };

  const handleNewPasswordHover = () => {
    setNewPasswordHover(!newPasswordHover);
  };

  return (
    <>
      <LoginLayoutV2 lang={true}>
        <Box
          style={{
            width: "62%",
            backgroundColor: "rgb(15 90 156 / 17%)",
            backdropFilter: "blur(5px)",
            padding: "40px 20px 40px 40px ",
            paddingBottom: "20px",
            borderRadius: "8px",
            overflowY: "auto",
            scrollbarWidth: "none",
          }}
        >
          <Box
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <img
              src={
                process.env.REACT_APP_ENVIRONMENT === "USA"
                  ? forgot_password
                  : vis_forgot_password
              }
              alt="logo"
              style={{ width: "180px" }}
            />
          </Box>
          <Grid
            container
            // spacing={2}s
            alignItems="center"
            style={{ display: "flex", marginTop: "8px" }}
          >
            <Grid item xs style={{ display: "flex" }}>
              <Grid className="forgotPassword_icon">
                <USAPassIcon className="visibleIcons" />
              </Grid>
              <USACustomTextfield
                type={values.showPassword ? "text" : "password"}
                error={error.password}
                name="password"
                required={true}
                label="New Password"
                value={values.password}
                handleChange={(e) => handleChange(e)}
                helperText={error.password}
                inputProps={{ maxLength: 25 }}
                //  validation='password'
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                        className="changePassword"
                      >
                        {values.showPassword ? (
                          <Visibility className="changePasswordvisibleIconsDark" />
                        ) : (
                          <VisibilityOff
                            className="changePasswordvisibleOffIcon"
                            style={{ transform: "scaleX(-1)" }}
                          />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                  maxLength: 25,
                }}
              />
            </Grid>
            <Grid>
              <Tooltip
                placement="bottom-start"
                title={
                  "Password must be at least 8 characters long and contains at least 1 number, 1 uppercase character, 1 lowercase character and 1 special character"
                }
                componentsProps={{
                  tooltip: {
                    sx: {
                      maxWidth: 450,
                    },
                  },
                }}
              >
                <img
                  src={newPasswordHover ? infoHover : info}
                  alt="logo"
                  className="info_img"
                  onMouseEnter={handleNewPasswordHover}
                  onMouseLeave={handleNewPasswordHover}
                />
              </Tooltip>
            </Grid>
          </Grid>
          <Grid
            container
            // spacing={2}
            alignItems="center"
            style={{ display: "flex" }}
          >
            <Grid item xs style={{ display: "flex" }}>
              <Grid className="forgotPassword_icon">
                <USAPassIcon className="visibleIcons" />
              </Grid>
              <USACustomTextfield
                type={values.confirmShowPassword ? "text" : "password"}
                error={error.confirmPassword}
                name="confirmPassword"
                label="Confirm Password"
                required={true}
                value={values.confirmPassword}
                handleChange={(e) => handleChange(e)}
                helperText={error.confirmPassword}
                inputProps={{ maxLength: 25 }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        className="changePassword"
                        onClick={handleClickConfirmShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {values.confirmShowPassword ? (
                          <Visibility className="changePasswordvisibleIconsDark" />
                        ) : (
                          <VisibilityOff
                            className="changePasswordvisibleOffIcon"
                            style={{ transform: "scaleX(-1)" }}
                          />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                  maxLength: 25,
                }}
              />
            </Grid>
            <Grid>
              <Tooltip
                placement="bottom-start"
                title={
                  "Password must be at least 8 characters long and contains at least 1 number, 1 uppercase character, 1 lowercase character and 1 special character"
                }
                componentsProps={{
                  tooltip: {
                    sx: {
                      maxWidth: 450,
                    },
                  },
                }}
              >
                <img
                  src={confirmPasswordHover ? infoHover : info}
                  alt="logo"
                  className="info_img"
                  onMouseEnter={handleConfirmPasswordHover}
                  onMouseLeave={handleConfirmPasswordHover}
                />
              </Tooltip>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={2}
            alignItems="center"
            style={{
              marginTop: "8px",
              width: "100%",
            }}
          >
            <Grid item xs={12}>
              <Button
                sx={{
                  backgroundColor: "#F2824C",
                  borderRadius: "10px !important",
                  fontWeight: 300,
                }}
                fullWidth
                variant="contained"
                type="submit"
                onClick={handleSubmit}
              >
                Reset Password
              </Button>
            </Grid>
            <Grid item xs={12}>
              <Box align="center">
                <Typography
                  variant="body2"
                  align="center"
                  style={{
                    fontSize: "12px",

                    color: "#fff",
                  }}
                >
                  {t("BACK_TO")}{" "}
                  <Link href="/vis/login" className="link_green">
                    {" "}
                    {t("LOGINFORM0002")}
                  </Link>
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </LoginLayoutV2>
    </>
  );
}

export default withRouter(ChangePassword);
